import Vue from 'vue'
import Router from 'vue-router'
import Login from './components/Login'
import Home from './components/Home'
import Form from './components/Form'
import NewGuide from './components/NewGuide'


import auth from './auth'
// import store from './store/index'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {layout: 'loginLayout'}
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/form',
      name: 'form',
      component: Form,
    },
    {
      path: '/addGuide',
      name: 'NewGuide',
      component: NewGuide,
    },
    
  ],
  scrollBehavior(to, from, savedPosition){
    const position = { x: 0, y: 0 };
    return position
  }
});

router.beforeEach((to, from, next) =>  {
  auth.checkAuth() // Internally this gets the token from localStorage, and sets user.authenticated to true if it's there
  
  if (to.path == '/login'){ //without it too recursive?
    next()
  }else if(to.path !== '/login'  && to.path !== '/' && !auth.user.authenticated) { // Not logged in? You get booted to /login
    next('/login');
  } 
  else{ 
    next() 
  }

});


export default router;